import { useEffect, useState } from "react";
import { Box, IconButton, Tab, Tabs, Tooltip, Typography } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import SystemMonitorServer from "../components/SystemMonitorServer";
import SystemMonitorSystem from "../components/SystemMonitorSystem";
import { openExternalPath } from "../utils/externalLinks";

type SystemMonitorTab = "server" | "system";
const TAB_STORAGE_KEY = "systemMonitorPage.tab";

const SystemMonitorPage = () => {
  const [tab, setTab] = useState<SystemMonitorTab>("system");

  useEffect(() => {
    const storedTab = localStorage.getItem(TAB_STORAGE_KEY);
    if (storedTab === "server" || storedTab === "system") {
      setTab(storedTab);
    }
  }, []);

  const handleTabChange = (_: unknown, value: SystemMonitorTab) => {
    setTab(value);
    localStorage.setItem(TAB_STORAGE_KEY, value);
  };

  const handleOpenSystemMonitorHelp = () => {
    if (typeof window === "undefined") {
      return;
    }
    void openExternalPath("/help/user-guide/system-monitor.html");
  };

  return (
    <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
      <Box sx={{ px: 2, pt: 2 }}>
        <Box sx={{ mb: 1, display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="h5" sx={{ m: 0 }}>
            📊 System Monitor
          </Typography>
          <Box sx={{ flexGrow: 1 }} />
          <Tooltip title="Help">
            <IconButton
              size="small"
              onClick={handleOpenSystemMonitorHelp}
              aria-label="Open system monitor help"
            >
              <HelpOutlineIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
        <Tabs
          value={tab}
          onChange={handleTabChange}
          aria-label="system monitor tabs"
          textColor="primary"
          indicatorColor="primary"
        >
          <Tab label="Server" value="server" />
          <Tab label="System" value="system" />
        </Tabs>
      </Box>
      <Box sx={{ flex: 1 }}>
        {tab === "server" && <SystemMonitorServer />}
        {tab === "system" && <SystemMonitorSystem />}
      </Box>
    </Box>
  );
};

export default SystemMonitorPage;
